var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMoreCours(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 696,
    viewBox: "0 0 375 696",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_11489_32621)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 145.5,
    cy: 291.5,
    r: 87.5,
    fill: "#0054A3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145.5,
    cy: 291.5,
    r: 87.5,
    fill: "#0054A3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145.5,
    cy: 291.5,
    r: 87.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145.5,
    cy: 291.5,
    r: 87.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145.5,
    cy: 291.5,
    r: 87.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145.5,
    cy: 291.5,
    r: 87.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145.5,
    cy: 291.5,
    r: 87.5,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_11489_32621)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 263,
    cy: 265,
    r: 73,
    fill: "#ECEDFF",
    fillOpacity: 0.73
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_11489_32621)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 227,
    r: 73,
    fill: "#ECEDFF",
    fillOpacity: 0.73
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_11489_32621)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 286,
    r: 73,
    fill: "#ECEDFF",
    fillOpacity: 0.73
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_11489_32621)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 93,
    cy: 286,
    r: 73,
    fill: "#ECEDFF",
    fillOpacity: 0.73
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_11489_32621)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 199,
    r: 73,
    fill: "#ECEDFF",
    fillOpacity: 0.73
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_11489_32621)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 388,
    r: 73,
    fill: "#ECEDFF",
    fillOpacity: 0.73
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_11489_32621)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 177,
    cy: 379,
    r: 73,
    fill: "#ECEDFF",
    fillOpacity: 0.73
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_11489_32621)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 228,
    cy: 252,
    r: 73,
    fill: "#ECEDFF",
    fillOpacity: 0.73
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_11489_32621)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 227,
    r: 73,
    fill: "#ECEDFF",
    fillOpacity: 0.73
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11489_32621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.233 367.437H156.345C155.124 367.438 153.915 367.178 152.787 366.673C151.659 366.169 150.635 365.429 149.773 364.497C148.91 363.565 148.227 362.459 147.761 361.242C147.296 360.024 147.058 358.72 147.06 357.403V336.904C147.06 334.307 148.017 331.817 149.72 329.98C151.423 328.144 153.732 327.112 156.14 327.112H253.233V367.411V367.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8786 343.721V349.785C67.8656 352.869 68.5344 355.912 69.8293 358.662C72.3239 363.908 76.9388 367.438 82.2372 367.438H256.082C257.229 367.438 258.162 366.291 258.162 364.876V363.973C258.162 362.558 257.229 361.412 256.082 361.412H150.089C149.509 360.549 149.008 359.628 148.592 358.662C147.558 356.247 147.027 353.618 147.035 350.958V343.253C147.034 341.872 147.178 340.494 147.464 339.148C147.919 337.001 148.754 334.97 149.924 333.165H256.082C257.229 333.165 258.162 332.019 258.162 330.604V329.7C258.162 328.285 257.229 327.139 256.082 327.139H81.3641C75.2026 327.139 70.0139 332.213 68.3925 339.148C68.0472 340.644 67.8746 342.18 67.8786 343.721Z",
    fill: "#219CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.233 347.288L240.361 347.966L253.233 348.375V347.288Z",
    fill: "#A8BFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.233 353.61L222.61 354.288L253.233 354.697V353.61Z",
    fill: "#A8BFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.071 282.31H212.183C209.72 282.31 207.359 281.256 205.618 279.378C203.876 277.5 202.898 274.953 202.898 272.298V251.799C202.898 249.202 203.855 246.711 205.558 244.875C207.261 243.038 209.57 242.007 211.978 242.007H309.071V282.305V282.31Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.721 258.621V264.685C123.709 267.77 124.376 270.814 125.667 273.567C128.162 278.813 132.782 282.343 138.08 282.343H311.919C312.51 282.298 313.06 282.005 313.451 281.525C313.841 281.045 314.041 280.419 314.005 279.782V278.872C314.041 278.236 313.841 277.61 313.451 277.131C313.06 276.652 312.51 276.36 311.919 276.317H205.966C205.39 275.452 204.889 274.532 204.47 273.567C203.438 271.152 202.909 268.522 202.918 265.863V258.126C202.917 256.746 203.061 255.371 203.347 254.026C203.799 251.88 204.633 249.848 205.802 248.043H311.919C312.51 247.999 313.06 247.705 313.451 247.226C313.841 246.746 314.041 246.119 314.005 245.482V244.578C314.005 243.163 313.072 242.012 311.919 242.012H137.202C131.045 242.012 125.852 247.091 124.23 254.026C123.885 255.529 123.714 257.073 123.721 258.621Z",
    fill: "#219CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.076 262.167L296.204 262.844L309.076 263.248V262.167Z",
    fill: "#A8BFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.076 268.488L278.453 269.166L309.076 269.575V268.488Z",
    fill: "#A8BFEF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_11489_32621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.701 367.351H298.489C300.323 367.351 302.082 368.137 303.378 369.536C304.675 370.934 305.404 372.831 305.404 374.809V390.756C305.404 392.862 304.628 394.882 303.247 396.371C301.866 397.86 299.993 398.697 298.04 398.697H201.701V367.351Z",
    fill: "#0054A3"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_11489_32621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.782 367.351H211.779C213.651 367.351 215.447 368.154 216.771 369.581C218.094 371.009 218.838 372.945 218.838 374.965V390.906C218.838 392.971 218.078 394.951 216.724 396.411C215.37 397.871 213.534 398.692 211.619 398.692H102.782V367.351Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M226.496 394.011H98.4666C97.8769 394.011 97.3989 394.526 97.3989 395.162V397.546C97.3989 398.182 97.8769 398.697 98.4666 398.697H226.496C227.086 398.697 227.564 398.182 227.564 397.546V395.162C227.564 394.526 227.086 394.011 226.496 394.011Z",
    fill: "#0054A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.496 367.351H98.4666C97.8769 367.351 97.3989 367.867 97.3989 368.503V370.886C97.3989 371.522 97.8769 372.038 98.4666 372.038H226.496C227.086 372.038 227.564 371.522 227.564 370.886V368.503C227.564 367.867 227.086 367.351 226.496 367.351Z",
    fill: "#0054A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.782 383.024L116.851 383.552L102.782 383.869V383.024Z",
    fill: "#B9CAF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.782 375.815L136.259 376.342L102.782 376.659V375.815Z",
    fill: "#B9CAF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.536 376C175.598 376.966 174.936 378.202 174.63 379.562C174.541 379.968 174.491 380.382 174.481 380.799C174.401 383.742 174.481 390.398 174.481 390.398L170.245 387.067L166.004 390.398V381.375C165.957 379.816 166.316 378.275 167.042 376.925C167.153 376.681 167.318 376.47 167.521 376.309C167.724 376.148 167.96 376.042 168.209 376H176.536Z",
    fill: "#739CE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.536 376C175.598 376.966 174.937 378.202 174.63 379.562L166.149 379.691C166.149 379.691 166.483 376.522 168.234 376H176.536Z",
    fill: "#618BD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.038 327.225H172.29C169.476 327.225 166.777 326.019 164.787 323.873C162.796 321.727 161.678 318.816 161.678 315.781V292.355C161.678 289.389 162.771 286.544 164.716 284.446C166.662 282.348 169.3 281.17 172.051 281.17H276.038V327.225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.629 299.038V308.948C161.653 313.183 163.529 316.857 166.293 318.821C167.658 319.801 169.259 320.327 170.898 320.333H279.052C280.319 320.333 281.346 321.613 281.346 323.195V324.363C281.346 325.945 280.319 327.225 279.052 327.225H92.2155C86.8522 327.225 82.1176 323.905 79.2439 318.821C77.3519 315.407 76.3616 311.5 76.3801 307.522V299.683C76.3774 296.913 76.8862 294.169 77.8769 291.613C80.2816 285.42 85.3605 281.148 91.2576 281.148H279.052C280.319 281.148 281.346 282.429 281.346 284.005V285.178C281.346 286.754 280.319 288.035 279.052 288.035H170.569C169.293 288.059 168.039 288.393 166.899 289.013C165.76 289.632 164.765 290.521 163.988 291.613C162.447 293.729 161.615 296.346 161.629 299.038Z",
    fill: "#0054A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.038 304.198L262.173 304.972L276.038 305.44V304.198Z",
    fill: "#B9CAF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.038 293.598L243.055 294.373L276.038 294.841V293.598Z",
    fill: "#B9CAF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.327 294.217C171.327 294.217 173.502 295.68 174.226 298.08C174.358 298.513 174.433 298.964 174.45 299.42C174.57 302.61 174.45 309.831 174.45 309.831L180.876 306.22L187.287 309.831V300.049C187.338 298.281 186.778 296.555 185.716 295.207C185.5 294.917 185.231 294.678 184.925 294.506C184.619 294.334 184.284 294.232 183.94 294.206L171.327 294.217Z",
    fill: "#EB9A57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.327 294.217C171.327 294.217 173.502 295.68 174.226 298.08L187.103 298.22C187.103 298.22 186.604 294.787 183.94 294.217H171.327Z",
    fill: "#DE8140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.055 327L304.778 332.547L296.276 331.315L293.477 339.176L286.977 339.38L287.071 342.931L295.767 342.662L298.417 335.21L307.262 336.491L309.188 328.141L306.055 327Z",
    fill: "#FF724F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.393 214.74L185.656 205.206L176.252 203.118C176.011 203.065 175.789 202.94 175.61 202.758C175.432 202.576 175.305 202.343 175.242 202.087C175.18 201.831 175.185 201.56 175.258 201.307C175.331 201.054 175.467 200.828 175.653 200.654L182.907 193.87L181.839 183.582C181.811 183.318 181.851 183.05 181.957 182.809C182.063 182.568 182.229 182.364 182.438 182.22C182.646 182.077 182.887 181.999 183.134 181.996C183.381 181.994 183.624 182.066 183.835 182.205L192.057 187.553L200.793 183.297C201.017 183.189 201.265 183.15 201.508 183.185C201.751 183.22 201.981 183.327 202.171 183.494C202.361 183.662 202.504 183.883 202.584 184.133C202.664 184.384 202.678 184.653 202.624 184.911L200.479 194.978L206.965 202.623C207.13 202.82 207.241 203.062 207.285 203.323C207.33 203.584 207.306 203.854 207.216 204.101C207.127 204.348 206.975 204.563 206.778 204.722C206.581 204.881 206.347 204.978 206.101 205.001L196.487 205.895L191.748 214.89C191.625 215.118 191.445 215.304 191.23 215.429C191.015 215.553 190.771 215.611 190.527 215.595C190.284 215.58 190.048 215.492 189.848 215.341C189.648 215.189 189.49 214.982 189.393 214.74Z",
    fill: "#0074E4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.2864 203L62.6743 209.111L68.9221 209.357L71.1477 216.412L77.8784 214.456L80.7184 222.314L87.1246 221.336L91 228.412L88.5233 230L85.6254 224.709L78.8676 225.741L76.1359 218.184L69.293 220.178L66.8395 212.391L60.7346 212.153L58.5245 206.486L54.4868 207.238L54 204.166L60.2864 203Z",
    fill: "#FF724F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M255.283 153.466L252.839 147.508L246.688 146.203C246.531 146.17 246.386 146.092 246.269 145.978C246.152 145.864 246.069 145.719 246.028 145.559C245.987 145.398 245.991 145.23 246.038 145.071C246.086 144.913 246.175 144.772 246.297 144.663L251.041 140.42L250.343 133.991C250.324 133.826 250.351 133.658 250.42 133.508C250.489 133.357 250.598 133.23 250.734 133.14C250.87 133.05 251.028 133.002 251.19 133C251.351 132.998 251.51 133.044 251.648 133.131L257.025 136.469L262.742 133.8C262.888 133.731 263.051 133.705 263.211 133.726C263.37 133.747 263.521 133.814 263.646 133.919C263.77 134.024 263.864 134.163 263.916 134.321C263.968 134.478 263.976 134.647 263.939 134.808L262.533 141.116L266.775 145.894C266.883 146.016 266.956 146.168 266.986 146.331C267.015 146.494 266.999 146.662 266.941 146.816C266.882 146.971 266.782 147.105 266.653 147.204C266.524 147.303 266.371 147.363 266.21 147.377L259.923 147.935L256.823 153.556C256.743 153.699 256.626 153.816 256.485 153.894C256.344 153.972 256.185 154.008 256.026 153.999C255.866 153.989 255.712 153.934 255.581 153.84C255.45 153.746 255.347 153.617 255.283 153.466Z",
    fill: "#0054A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M193.997 445.299C249.225 445.299 293.995 440.531 293.995 434.649C293.995 428.768 249.225 424 193.997 424C138.77 424 94 428.768 94 434.649C94 440.531 138.77 445.299 193.997 445.299Z",
    fill: "#0054A8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_11489_32621",
    x: -177,
    y: -31,
    width: 645,
    height: 645,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 117.5,
    result: "effect1_foregroundBlur_11489_32621"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_11489_32621",
    x: -45,
    y: -43,
    width: 616,
    height: 616,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 117.5,
    result: "effect1_foregroundBlur_11489_32621"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_11489_32621",
    x: -44,
    y: -81,
    width: 616,
    height: 616,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 117.5,
    result: "effect1_foregroundBlur_11489_32621"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_11489_32621",
    x: -110,
    y: -22,
    width: 616,
    height: 616,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 117.5,
    result: "effect1_foregroundBlur_11489_32621"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_11489_32621",
    x: -215,
    y: -22,
    width: 616,
    height: 616,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 117.5,
    result: "effect1_foregroundBlur_11489_32621"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_11489_32621",
    x: -117,
    y: -109,
    width: 616,
    height: 616,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 117.5,
    result: "effect1_foregroundBlur_11489_32621"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_11489_32621",
    x: -99,
    y: 80,
    width: 616,
    height: 616,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 117.5,
    result: "effect1_foregroundBlur_11489_32621"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_11489_32621",
    x: -131,
    y: 71,
    width: 616,
    height: 616,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 117.5,
    result: "effect1_foregroundBlur_11489_32621"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_11489_32621",
    x: -80,
    y: -56,
    width: 616,
    height: 616,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 117.5,
    result: "effect1_foregroundBlur_11489_32621"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_11489_32621",
    x: -37,
    y: -81,
    width: 616,
    height: 616,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 117.5,
    result: "effect1_foregroundBlur_11489_32621"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_11489_32621",
    x: 197.701,
    y: 367.351,
    width: 111.703,
    height: 39.3457,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11489_32621"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11489_32621",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_11489_32621",
    x: 98.7822,
    y: 367.351,
    width: 124.056,
    height: 39.3402,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11489_32621"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11489_32621",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11489_32621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 249,
    height: 263,
    fill: "white",
    transform: "translate(65 182)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoreCours);
export default __webpack_public_path__ + "static/media/iconMoreCours.fad55dd4d4701c124b6a41fd1b7e4b41.svg";
export { ForwardRef as ReactComponent };